import { h, FunctionalComponent } from '@stencil/core';
import state from '@ugc-store';
import { ReportAbuseType } from '@ugc-containers/ugc-report-abuse/interfaces';
import { ChevronRight } from '../../../icons';
import { isRtl } from '@ugc-utils/utils';
import { TopReviewType } from '@ugc-components/ugc-pdp-review/interface';

interface IProps {
  type: TopReviewType;
}

const TopReviewItem: FunctionalComponent<IProps> = ({ type }) => {
  const handleClickView = () => {
    state.isShowReviewSummaryModal = true;
    state.reviewSummaryModalType = type;
  };

  const {
    reviewStaticLanguage: {
      IDS_MSG_SHOW_MORE = '',
      IDS_LBL_MOST_HELPFUL_CRIT_REVIEW = '',
      IDS_LBL_MOST_HELPFUL_POSI_REVIEW = '',
    },
    reviewSummary,
    isDesktop,
  } = state;
  const {
    id,
    customerNickname,
    customerProfileLink,
    profileImageUrl,
    ratingValue,
    reviewTitle,
    reviewText,
    postedDateLocalized,
    helpfulNo,
    helpfulYes,
    hasThumbsUp,
    shareUrl,
    country,
  } = reviewSummary[type];
  const title =
    type === TopReviewType.TopPositiveReview ? IDS_LBL_MOST_HELPFUL_POSI_REVIEW : IDS_LBL_MOST_HELPFUL_CRIT_REVIEW;
  return (
    <div class="grow-0 shrink-0 w-full" style={{ maxWidth: 'calc(50% - 10px)' }}>
      <div class="fs-20 bold color-gray-700 mb-16">{title}</div>
      <div class="p-24 border-1 border-solid border-gray-300 rounded-16">
        <div class="flex-row-between-center mb-16 flex-wrap">
          <div class="flex-row-start-center gap-8">
            <ugc-review-avatar size="48" profileImageUrl={profileImageUrl} customerProfileLink={customerProfileLink} />
            <div class="flex-col-start-start">
              <ugc-review-nickname customerProfileLink={customerProfileLink} customerNickname={customerNickname} />
              {!!country && <span class={`mt-4 ${isDesktop ? 'fs-14 lh-20' : 'fs-12 lh-26'}`}>{country}</span>}
            </div>
          </div>
          <span class="fs-14 lh-16 color-gray-500">{postedDateLocalized}</span>
        </div>

        <div class="flex-row-start-center mt-20 gap-8 flex-wrap">
          <ugc-with-link url={shareUrl}>
            <ugc-star withTips={false} disabled={true} size={24} realValue={ratingValue} />
          </ugc-with-link>
          <ugc-review-title reviewTitle={reviewTitle} shareUrl={shareUrl} />
        </div>

        <div class="mt-16" style={{ minHeight: '72px' }}>
          <ugc-with-link url={shareUrl}>
            <p class="fs-16 lh-24 color-gray-700 ellipsis-text-3">{reviewText}</p>
          </ugc-with-link>
        </div>

        <div class="fs-14 lh-24 flex-row-start-center ">
          <div class="flex-row-start-center pointer gap-4" onClick={handleClickView}>
            <span class="fs-16 fw-400 color-blue-dark">{IDS_MSG_SHOW_MORE}</span>
            <span class="flex-row-start-center" style={{ transform: isRtl() ? 'rotate(180deg)' : 'rotate(0deg)' }}>
              <ChevronRight width="24" height="24" fill="#126cc5" />
            </span>
          </div>
        </div>
        <div class="flex-row-between-center flex-wrap mt-24">
          <ugc-review-vote rid={id} helpfulNo={helpfulNo} helpfulYes={helpfulYes} hasThumbsUp={hasThumbsUp} />
          <div class="flex-row-start-center gap-14">
            <ugc-report-abuse type={ReportAbuseType.Review} referenceId={id} />
            <span class="lh-16">
              <ugc-share
                sid={`${type}-${id}`}
                shareUrl={shareUrl}
                gaEvent={{
                  'data-ga-event-name': 'open_share_widget',
                  'data-ga-content-type': 'review',
                  'data-ga-location-detail': 'pdp review',
                }}
              />
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopReviewItem;
